import { useEffect, useState } from "react";
import { getPayURL } from "../utils/ConstantsURL";

export const useFetchPays = (token, selectedDate, refresh, idDocument) => {
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(getPayURL(selectedDate, idDocument), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setDatos(data.data);
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        console.error("Error al obtener los indicators:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, selectedDate, refresh, idDocument]);

  return { datos, loading };
};
